import React, { useState, useEffect } from "react";

export default function PHDNotification() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div
      style={{
        padding: "20px",
        marginTop:
          windowWidth < 768 ? "50px" : windowWidth < 1300 ? "150px" : "300px",
        marginBottom: "50px",
      }}
    >
      <h1 style={{ textAlign: "center", color: "#162544" }}>
        PHD Exam Notifications
      </h1>
      <ul
        style={{
          listStyleType: "disc",
          paddingLeft: "20px",
          marginTop: windowWidth < 768 ? "10px" : "20px",
          maxWidth: "1200px",
          margin: "0 auto",
        }}
      >
        <li style={{ padding: "15px 0" }}>
          <a
            target="_blank"
            href="https://jssuninoida.edu.in/assets/circulars/website_updation_20250606152100.pdf"
          >
            Ph.D Admissions (FT/PT) Notification (April Session 2025)
          </a>
        </li>
      </ul>
    </div>
  );
}
